import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import { Box, Container, Flex, Heading, Image } from "theme-ui"
import Breadcrumbs from "../components/breadcrumbs"
import underline from "../assets/images/segno.svg"
import RichContentStructuredText from "../components/richContentStructuredText"

const PageHero = ({
  page,
  image,
  icon,
  theme = "dark",
  showTitle = true,
  isArticle,
}) => (
  <Box
    sx={{
      position: "relative",
      backgroundColor: "primary",
      borderBottomLeftRadius: ["50px", "100px"],
    }}
  >
    {image && (
      <>
        {image.url && image.mimeType !== "image/jpeg" ? (
          <Box
            sx={{
              height: "100%",
              width: "100%",
              position: "absolute",
              top: 0,
              left: 0,
              backgroundColor: "primary",
              overflow: "hidden",
              video: {
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "center",
              },
            }}
          >
            <video
              title={"background-video"}
              id=""
              class=""
              loop
              autoPlay
              muted
              playsinline="playsinline"
            >
              <source src={image.url} type={image.mimeType} />
            </video>
          </Box>
        ) : (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              height: "100%",
              width: "100%",
              ".gatsby-image-wrapper": { width: "100%", height: "100%" },
              overflow: "hidden",
              borderBottomLeftRadius: ["50px", "100px"],
            }}
          >
            <GatsbyImage image={image.gatsbyImageData} />
          </Box>
        )}
      </>
    )}

    <Container
      sx={{
        paddingTop: [6, 10, 12],
        pb: [6, 10],
        position: "relative",
      }}
    >
      <Breadcrumbs page={page} />
      <Box
        sx={{
          mt: [4],
          "h1,h2,h3": {
            color: "light",
            fontSize: [6, 8],
            fontWeight: "300",
            strong: {
              fontWeight: "300",
            },
          },
        }}
      >
        {showTitle ? (
          <Flex
            sx={{
              flexDirection: "column",
              em: {
                backgroundImage: `url(${underline})`,
                backgroundPosition: "bottom",
                backgroundRepeat: "no-repeat",
                pb: "15px",
                mt: "-15px",
                mr: "5px",
              },
            }}
          >
            {icon && (
              <Box
                sx={{
                  mb: [3, 4, 6],
                  mt: [3, 4],
                  display: "block",
                  img: { display: "block", height: ["60px", "80px"] },
                }}
              >
                <Image src={icon.url} />
              </Box>
            )}
            <RichContentStructuredText text={page.body} />
          </Flex>
        ) : (
          <>{isArticle ? null : <Heading as="h1">{page.title}</Heading>}</>
        )}
      </Box>
    </Container>
  </Box>
)

export default PageHero
